<template>
  <div>
    <b-button
      class="m-md-2 b-secondary"
      style="margin: 0"
      @click="showPartnerCallModal = true"
    >
      <span class="material-icons text-decoration-none text-white p-2 rounded">
        phone
      </span>
    </b-button>
    <CallContactModal
      :visible="showPartnerCallModal"
      :contactList="filteredContactList"
      @hide="showPartnerCallModal = false"
      @call-initiated="onCallInitiated"
    />
  </div>
</template>

<script>
import CallContactModal from '@/components/CallContactModal.vue';

export default {
  components: {
    CallContactModal,
  },
  props: {
    contactList: {
      type: Array,
      default: () => [],
    },
    roleFilter: {
      type: Array,
      default: () => [],
    },
    jobApiId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showPartnerCallModal: false,
    };
  },
  computed: {
    filteredContactList() {
      return this.contactList
        .map((jc) => {
          const phoneRegex = /[+,\d]/g;
          let phone = null;
          let mobilePhone = null;

          if (jc.mobilePhone && phoneRegex.test(jc.mobilePhone)) {
            mobilePhone = jc.mobilePhone;
          }
          if (jc.phone && phoneRegex.test(jc.phone)) {
            phone = jc.phone;
          }

          return {
            ...jc,
            phone,
            mobilePhone,
          };
        })
        .filter(
          (jc) =>
            jc.jobRole &&
            (jc.phone || jc.mobilePhone) &&
            (!this.roleFilter || this.roleFilter.includes(jc.jobRole)),
        )
        .sort((a, b) => (a.lastName || '').localeCompare(b.lastName || ''));
    },
  },
  methods: {
    onCallInitiated(selectedContact) {
      if (selectedContact) {
        window.open(`tel:${selectedContact.phone}`);
      }

      this.$emit('call-initiated', {
        selectedContact,
        jobApiId: this.jobApiId,
      });
    },
  },
};
</script>
